var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-container",on:{"click":_vm.change}},[_c('div',{staticClass:"checkbox-itself",class:{'checked': _vm.is_true}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }